<template>
    <div>
        <div class="row" v-if="!openDay">
            <breadcrumb>
              <template v-slot:1>
                <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
              </template>
              <template v-slot:2>
                <li class="breadcrumb-item active" aria-current="page">{{$t("informePedidos")}}</li>
              </template>
            </breadcrumb>
            <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                :hoursto="hoursto"
                :hoursfrom="hoursfrom"
                :conBusquedaPorHoras="true"
                id="cabecera"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <template v-if="data.length > 0">
                    <div class="row justify-content-between div-export">

                        <div class="row justify-content-right" style="margin-left:15px">
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu v-if="graficaVentas===0" slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                                <el-dropdown-menu v-else slot="dropdown">
                                    <a :href="urlExportPDFInformes">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcelInformes">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="row justify-content-right" style="margin-right:15px">
                            <el-button-group>
                                <el-button @click="openDays()" size="small"> {{$t("dias")}}
                                </el-button>
                                <el-button @click="openSemanas()" size="small"> {{$t("semanas")}}
                                </el-button>
                                <el-button @click="openMeses()" size="small"> {{$t("meses")}}
                                </el-button>
                                <el-button @click="openHours()" size="small"> {{$t("horas")}}
                                </el-button>
                            
                                <el-button v-if="grafica===0" @click="buttonGrafica"
                                           type="primary" size="small" icon="fas fa-chart-bar"> {{$t("grafica")}}
                                </el-button>
                                <el-button v-else type="primary" @click="buttonGrafica" size="small"
                                           icon="fas fa-list-ul">
                                    {{$t("lista")}}
                                </el-button>
                            </el-button-group>
                        </div>
                    </div>

                    <div v-show="grafica===0" class="table-responsive">
                        <div v-show="graficaVentas===0">
                            <template>
                                <table class="table table-bordered table-striped tableVentas text-nowrap" id="myTable">
                                    <thead class="thead-dark">
                                    <tr style="cursor: pointer;">

                                        <th v-if="ordenacionFecha===0" @click="sortedArrayFechaASC('initDate')"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("fecha")}}
                                        </th>
                                        <th v-else @click="sortedArrayFechaDESC('initDate')"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("fecha")}}
                                        </th>

                                        <th v-if="ordenarRecoger===0" @click="sortedArrayRecogerASC()"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("numeroPedidosRecoger")}}
                                        </th>
                                        <th v-else @click="sortedArrayRecogerDESC()"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("numeroPedidosRecoger")}}
                                        </th>

                                        <th v-if="ordenarDomicilio===0" @click="sortedArrayDomicilioASC()"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("numeroPedidosDomicilio")}}
                                        </th>
                                        <th v-else @click="sortedArrayDomicilioDESC()"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("numeroPedidosDomicilio")}}
                                        </th>

                                        <th v-if="ordenarEfectivo===0" @click="sortedArrayEfectivoASC()"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("efectivo")}}
                                        </th>
                                        <th v-else @click="sortedArrayEfectivoDESC()"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("efectivo")}}
                                        </th>

                                        <th v-if="ordenarTarjetas===0" @click="sortedArrayTarjetasASC()"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("tarjetas")}}
                                        </th>
                                        <th v-else @click="sortedArrayTarjetasDESC()"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("tarjetas")}}
                                        </th>

                                        <th v-if="ordenarCheques===0" @click="sortedArrayChequesASC()"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("cheques")}}
                                        </th>
                                        <th v-else @click="sortedArrayChequesDESC()"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("cheques")}}
                                        </th>

                                        <th v-if="ordenarTotal===0" @click="sortedArrayTotalASC()"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{$t("total")}}
                                        </th>
                                        <th v-else @click="sortedArrayTotalDESC()"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("total")}}
                                        </th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(obj,index) in data" style="cursor: pointer" @click="getDayDetail(index)"
                                            class="trDay">

                                            <template v-if="graficaVentas===1">
                                                <td>
                                                    <span :class="getClassDay(obj.initDate)">{{obj.initDate | getDiaDeSemana}}</span>
                                                </td>
                                            </template>
                                            <template v-else-if="graficaVentas===2">
                                                <td>
                                                    <span>{{ obj.initDate | parseYear}}</span>
                                                </td>
                                            </template>
                                            <template v-else-if="graficaVentas===3">
                                                <td>
                                                    <span> {{obj.initDate | parseMonth}}</span>
                                                </td>
                                            </template>
                                            <template v-else-if="graficaVentas===4">
                                                <td>
                                                    <span> {{obj.initDate | parseHours}}</span>
                                                </td>
                                            </template>
                                            <template v-else>
                                                <td v-if="obj.observaciones">
                                                    <span :class="{'sunday':obj.initDate | getDia == 'D', 'fridaySaturday':obj.initDate | getDia == 'V', 'fridaySaturday':obj.initDate | getDia == 'S'}">{{obj.initDate | getDia}}
                                                        {{obj.initDate | parseDate}}
                                                    </span>
                                                    <i v-tooltip.top-center="obj.observaciones"
                                                    style="color: #0976b4"
                                                    class="fa fa-info-circle"></i>
                                                </td>
                                                <td v-else>
                                                    <span :class="getClassDay(obj.initDate)">{{obj.initDate | getDia}}
                                                        {{obj.initDate | parseDate}}
                                                    </span>
                                                </td>
                                            </template>
                                    
                                            <td align="right">{{obj.numRecoger}}</td>
                                            <td align="right">{{obj.numDomicilio}}</td>
                                            <td align="right">{{obj.money | currency}}</td>
                                            <td align="right">{{obj.cards | currency}}</td>
                                            <td class="right" align="right">{{obj.checks | currency}}</td>
                                            <td class=" text-right table-success" align="right">{{(obj.money + obj.cards + obj.pending
                                            ) |currency}}
                                            </td>

                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="table-success"><strong>{{$t("total")}}:</strong></td>
                                            <td class="text-right table-success"><strong>{{getTotalRecoger}}</strong></td>
                                            <td class="text-right table-success"><strong>{{getTotalDomicilio}}</strong></td>
                                            <td class="text-right table-success"><strong>{{getTotalEfectivo
                                                |currency}}</strong>
                                            </td>
                                            <td class="text-right table-success"><strong>{{getTotalTarjeta | currency}}</strong></td>
                                            <td class="text-right table-success"><strong>{{getTotalCheques | currency}}</strong></td>

                                            <td class="text-right table-success"><strong>{{getTotalTotal | currency}}</strong></td>
                                        
                                        </tr>

                                        <tr class="table-warning">
                                            <td class="table-success"><strong>{{$t("mediaSesion")}}:</strong></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="text-right "><strong>{{getTotalSesionMedia | currency}}</strong> <i
                                                    v-tooltip.top-center="$i18n.t('atencionLaMediaSinContarLosDiasConVentas') + getTotalVentasSinVentas +' €'"
                                                    style="color: darkred" class="fa fa-info-circle"></i></td>
                                        </tr>

                                    </tfoot>
                                </table>
                            </template>
                        </div>
                        <div v-show="graficaVentas!==0">
                            <div class="row">
                                <div class="col-md-6">

                                    <table class="table table-bordered table-striped tableVentas text-nowrap">
                                        <thead class="thead-dark">
                                        <tr style="cursor: pointer;">

                                            <th>
                                                {{$t("fecha")}}
                                            </th>

                                            <th>
                                                {{$t("ventas")}}
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="obj in data" style="cursor: pointer"
                                            class="trDay">

                                            <template v-if="graficaVentas===1">
                                                <td>
                                                <span style="text-transform: capitalize"
                                                      :class="getClassDay(obj.initDate)">{{obj.initDate | getDiaDeSemana}}</span>
                                                </td>
                                            </template>
                                            <template v-else-if="graficaVentas===2">
                                                <td>
                                                    <span style="text-transform: capitalize">{{ obj.initDate | parseYear}}</span>
                                                </td>
                                            </template>
                                            <template v-else-if="graficaVentas===3">
                                                <td>
                                                    <span style="text-transform: capitalize"> {{obj.initDate | parseMonth}}</span>
                                                </td>
                                            </template>
                                            <template v-else-if="graficaVentas===4">
                                                <td>
                                                    <span> {{obj.horas}}:00</span>
                                                </td>
                                            </template>

                                            <td align="right">

                                                <template v-if="graficaVentas!==4">{{obj.money + obj.cards
                                                    | currency}}
                                                </template>
                                                <template v-else>{{obj.amount | currency}}</template>
                                            </td>

                                        </tr>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td class="table-success"><strong>{{$t("total")}}:</strong></td>
                                            <td class="text-right table-success"><strong>
                                                <template >{{getTotalVentas |currency}}</template>
                                            </strong>
                                            </td>
                                        </tr>
                                        </tfoot>

                                    </table>
                                </div>

                                <div class="col-md-6">
                                    <div class="card">
                                        <div class="chart-container col-md-12" style="height:300px; width: 100%;">
                                            <canvas id="chartList"></canvas>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div v-show="grafica!==0">
                        <div class="card">
                            <div class="chart-container col-md-12" style="height:300px; width: 100%;">
                                <canvas id="chart"></canvas>
                            </div>

                        </div>

                    </div>

                </template>
                <template v-else>

                    <div class="alert alert-danger" role="alert">
                        {{$t("noHayVentasEnEsteRangoDeFechas")}}
                    </div>
                </template>

            </div>

        </div>
        <div class="row" v-else>
            <div class="col-md-12">
                <vue-tabs @tab-change="handleTabChange" v-model="tabs">
                    <v-tab title="Volver" icon="fa fa-arrow-circle-left">
                    </v-tab>
                    <v-tab title="Cierre">
                        <cierre v-if="tabs=='Cierre'" :idBusiness="idBusiness" :idDay="idDay"></cierre>
                    </v-tab>
                    <v-tab title="Tickets">
                        <tickets v-if="tabs=='Tickets'" :idBusiness="idBusiness" :idDay="idDay"
                                 :idTpv="idTpv"></tickets>
                    </v-tab>
                    <v-tab title="Incidencias">
                        <incidencias v-if="tabs=='Incidencias'" :idBusiness="idBusiness" :idDay="idDay"></incidencias>
                    </v-tab>
                    <v-tab title="Agencias">
                        <agencias v-if="tabs=='Agencias'" :idBusiness="idBusiness" :idDay="idDay"></agencias>
                    </v-tab>
                </vue-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import Datetime from 'vue-datetime'
    import {
        Button,
        ButtonGroup,
        Checkbox,
        CheckboxGroup,
        DatePicker,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Option,
        Select,
        Loading
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
    import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb.vue'
    import Terms from "../../../GeneralViews/Terms";
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = true;
            this.$store.dispatch("setNameRoute", this.$i18n.t("informePedidos"));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

        },

        components: {
         
            CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Datetime]: Datetime,
            [ButtonGroup.name]: ButtonGroup,
            Breadcrumb,
            Terms,
          
        },
        data() {
                CabeceraInformes
            return {

                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),

                hoursfrom: "00:00:00",
                hoursto: "23:59:59",
                listBusinesses: [],
                data: [''],
                listTpv: [],
                idTpv: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                cuentasAparcadas: false,
                dateInform: [],
                dateRangeOptions1Comercial: {
                    firstDayOfWeek: 1,
                },
                idBusiness: 0,
                observar: 0,
                idsTPV: [],
                listCheckBoxTpv: [],
                busquedaPorHoras: false,
                busquedaPorApertura: false,
                ordenacionFecha: 0,
                ordenarVentas: 0,
                ordenarEfectivo: 0,
                ordenarTarjetas: 0,
                ordenarCheques: 0,

                ordenarRecoger: 0,
                ordenarDomicilio: 0,

                ordenarTotal: 0,
               
                openDay: false,
                tabs: "Cierre",
                idDay: 0,
                tickets: [],
                objectChart: null,
                objectChartList: null,
                grafica: 0,
                listGrafic: [],

                graficaVentas: 0,
                respuesta: false,

            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {

                var tpv = "";
                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });
            
            return this.$store.getters.apiUrl + "/products/exportVentasNegocioPedidos/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

            },
            urlExportExcel() {

                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });
            return this.$store.getters.apiUrl + "/products/exportVentasNegocioPedidos/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

           },

            urlExportPDFInformes() {

                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl + "/products/exportVentasPorNegocio/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&tipoVenta=" + this.graficaVentas + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcelInformes() {

                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });
                return this.$store.getters.apiUrl + "/products/exportVentasPorNegocio/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&tipoVenta=" + this.graficaVentas + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },


            getTotalTarjeta() {
                let uds = 0;
                this.data.forEach(function (d) {
                    uds += d.cards;
                });
                return uds;
            },
            
            getTotalCheques() {
                let uds = 0;
                this.data.forEach(function (d) {
                    uds += d.checks;
                });
                return uds;
            },
     
            getTotalEfectivo() {
                let partes = 0;
                this.data.forEach(function (d) {
                    partes += d.money;
                });
                return partes;
            },
                 
            getTotalRecoger() {
                let partes = 0;
                this.data.forEach(function (d) {
                    partes += d.numRecoger;
                });
                return partes;
            },
                 
            getTotalDomicilio() {
                let partes = 0;
                this.data.forEach(function (d) {
                    partes += d.numDomicilio;
                });
                return partes;
            },

            getTotalVentas() {
              
                let total = 0;
                let vm = this;
                if (this.data.length >= 1 && this.data[0] != "") {
                    this.data.forEach(function (d) {

                        if (vm.graficaVentas === 4) {

                            total += parseFloat(d.amount);

                        } else {


                            if(d.money==null){
                                d.money = parseFloat(0)
                            }

                            if(d.cards==null){
                                d.cards = 0
                            }

                            total += d.money + d.cards ;

                        }
                    });
                }
                
                return total;
            },
            getTotalVentasSinVentas() {
                let total = 0;
                let index = 0;
                this.data.forEach(function (d) {

                    if (d.money + d.cards !== 0) {

                        total += d.money + d.cards;

                        index++;

                    }
                });


                return Math.round((total / index) * 100) / 100;
            },


            getTotalTotal() {
                let total = 0;
                this.data.forEach(function (d) {
                    total += (d.money + d.cards );
                });
                return total;
            },
            getTotalRecuento() {
                let total = 0;
                this.data.forEach(function (d) {

                    if (d.countAmount != 0) {

                        total += d.countAmount ;
                    } else {

                        total += d.countAmount;
                    }
                });
                return total;
            },


            getTotalSesionMedia() {
                let total = 0;
                let sesiones = this.data.length;
                this.data.forEach(function (d) {

                    total += d.money + d.cards ;
                });
                return total / sesiones;
            },

        },
        methods: {
            //CABECERAS
            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }
                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = 0;
                this.idsTPV = [];
                this.getTpv();
            },
            emitirConsulta() {

                this.getVentas();
            },
            cambioTpv(idTpvData, filtrar) {

                this.idTpv = idTpvData;
                this.idsTPV = [];
                this.idsTPV.push(idTpvData);
                this.emitirConsulta();
            },
            cambioHora(dates) {
                this.datefrom = dates[0];
                this.dateto = dates[1];
            },
            cambioBuscarPorHoras(bpH) {
                this.busquedaPorHoras = bpH;
            },
            cambioHorasBusqueda(hoursfrom, hoursto) {
                this.hoursfrom = moment(hoursfrom).format("HH:mm:ss");
                this.hoursto = moment(hoursto).format("HH:mm:ss");
            },

            buttonGrafica() {

                if (this.grafica === 0) {

                    this.grafica = 1;

                    if (this.graficaVentas === 0) {

                        this.grafica = 1;
                        this.getVentasSinHoras();

                    } else if (this.graficaVentas === 1) {
                        this.grafica = 2;
                        this.getSumaryWeeks();
                    } else if (this.graficaVentas === 3) {

                        this.grafica = 4;
                        this.getVentasSinHoras();
                    } else if (this.graficaVentas === 4) {

                        this.grafica = 3;
                        this.getSumaryHours();
                    }

                } else {


                    if (this.grafica === 1) {

                        this.graficaVentas = 0;
                        this.getVentasSinHoras();

                    } else if (this.grafica === 2) {
                        this.graficaVentas = 1;
                        this.getVentasSinHoras();
                    } else if (this.grafica === 3) {

                        this.graficaVentas = 4;
                        this.getVentasSinHoras();
                    } else if (this.grafica === 4) {

                        this.graficaVentas = 3;
                        this.getVentasSinHoras();
                    }

                    this.grafica = 0;

                }

            },

            sortedArrayFechaASC: function () {
                this.ordenacionFecha = 1;

                function compare(a, b) {
                    if (a.initDate < b.initDate)
                        return -1;
                    if (a.initDate > b.initDate)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayFechaDESC: function () {
                this.ordenacionFecha = 0;

                function compare(a, b) {

                    if (a.initDate > b.initDate)
                        return -1;
                    if (a.initDate < b.initDate)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayVentasASC: function () {
                this.ordenarVentas = 1;

                function compare(a, b) {
                    if (a.money + a.cards < b.money + b.cards )
                        return -1;
                    if (a.money + a.cards  > b.money + b.cards )
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayVentasDESC: function () {
                this.ordenarVentas = 0;

                function compare(a, b) {

                    if (a.money + a.cards  > b.money + b.cards )
                        return -1;
                    if (a.money + a.cards < b.money + b.cards )
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayEfectivoASC: function () {
                this.ordenarEfectivo = 1;

                function compare(a, b) {
                    if (a.money < b.money)
                        return -1;
                    if (a.money > b.money)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayEfectivoDESC: function () {
                this.ordenarEfectivo = 0;

                function compare(a, b) {

                    if (a.money > b.money)
                        return -1;
                    if (a.money < b.money)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayTarjetasASC: function () {
                this.ordenarTarjetas = 1;

                function compare(a, b) {
                    if (a.cards < b.cards)
                        return -1;
                    if (a.cards > b.cards)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayTarjetasDESC: function () {
                this.ordenarTarjetas = 0;

                function compare(a, b) {

                    if (a.cards > b.cards)
                        return -1;
                    if (a.cards < b.cards)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayChequesASC: function () {
                this.ordenarCheques = 1;

                function compare(a, b) {
                    if (a.checks < b.checks)
                        return -1;
                    if (a.checks > b.checks)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayChequesDESC: function () {
                this.ordenarCheques = 0;

                function compare(a, b) {

                    if (a.checks > b.checks)
                        return -1;
                    if (a.checks < b.checks)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },    
            sortedArrayTotalASC: function () {
                this.ordenarTotal = 1;

                function compare(a, b) {
                    if (a.money + a.cards  < b.money + b.cards  )
                        return -1;
                    if (a.money + a.cards  > b.money + b.cards )
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayTotalDESC: function () {
                this.ordenarTotal = 0;

                function compare(a, b) {

                    if (a.money + a.cards > b.money + b.cards)
                        return -1;
                    if (a.money + a.cards  < b.money + b.cards )
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayRecuentoASC: function () {
                this.ordenarRecuento = 1;

                function compare(a, b) {
                    if (a.countAmount < b.countAmount)
                        return -1;
                    if (a.countAmount > b.countAmount)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayRecuentoDESC: function () {
                this.ordenarRecuento = 0;

                function compare(a, b) {

                    if (a.countAmount > b.countAmount)
                        return -1;
                    if (a.countAmount < b.countAmount)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayRecogerASC: function () {
                this.ordenarRecoger = 1;

                function compare(a, b) {
                    if (a.numRecoger < b.numRecoger)
                        return -1;
                    if (a.numRecoger > b.numRecoger)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayRecogerDESC: function () {
                this.ordenarRecoger = 0;

                function compare(a, b) {

                    if (a.numRecoger > b.numRecoger)
                        return -1;
                    if (a.numRecoger < b.numRecoger)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayDomicilioASC: function () {
                this.ordenarDomicilio = 1;

                function compare(a, b) {
                    if (a.numDomicilio < b.numDomicilio)
                        return -1;
                    if (a.numDomicilio > b.numDomicilio)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },
            sortedArrayDomicilioDESC: function () {
                this.ordenarDomicilio = 0;

                function compare(a, b) {

                    if (a.numDomicilio > b.numDomicilio)
                        return -1;
                    if (a.numDomicilio < b.numDomicilio)
                        return 1;
                    return 0;
                }

                return this.data.sort(compare);
            },

            openDays() {

                if (this.grafica !== 0) {

                    this.grafica = 1;
                    this.graficaVentas = 0;
                    this.getVentasSinHoras();
                } else {
                    this.graficaVentas = 0;
                    this.getVentasSinHoras();
                }
            },


            openSemanas() {

                if (this.grafica !== 0) {

                    this.graficaVentas = 1;
                    this.grafica = 2;
                    this.getSumaryWeeks();
                } else {

                    this.graficaVentas = 1;
                    this.getVentasSinHoras();
                }
            },
            openHours() {

                if (this.grafica !== 0) {

                    this.grafica = 3;
                    this.graficaVentas = 4;
                    this.getSumaryHours();
                } else {
                    this.graficaVentas = 4;
                    this.getVentasSinHoras();
                }
            },

            openMeses() {

                if (this.grafica !== 0) {

                    this.grafica = 4;
                    this.graficaVentas = 3;
                    this.getVentasSinHoras();
                } else {
                    this.graficaVentas = 3;
                    this.getVentasSinHoras();
                }
            },

            openModal() {

                this.$modal.show('filtradoTPV');

            },
            getBusiness() {
                var config = {
                    params: {

                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;


                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;

                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        if(vm.idBusiness == 0) {
                            swal({
                                title: vm.$t('atencion'),
                                text: vm.$t('licenciaCaducada'),
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            vm.respuesta = false;
                        } else {
                            vm.getTpv();
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getTpv() {

                if (this.idBusiness.length > 0) {

                    this.listTpv = [];
                    this.idsTPV = [];
                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                        .then(function (response) {
                            if (response.data.response) {


                                vm.listTpv = [];
                                vm.idsTPV = [];

                                for (let i = 0; i < response.data.result.length; i++) {
                                    vm.idsTPV.push(response.data.result[i].id)
                                }

                                vm.idTpv = response.data.result[0].id;

                                vm.listCheckBoxTpv = response.data.result;


                                for (let i = 0; i < response.data.result.length; i++) {

                                    let printername = {
                                        nameShow: response.data.result[i].nameShow,
                                        id: response.data.result[i].id
                                    };

                                    vm.listTpv.push(printername)
                                }


                                vm.getVentas();
                                vm.grafica = 0;

                            }
                            vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },
            changeTPV() {
                if (this.idTpv === 0) {
                    this.idsTPV = [];
                    for (let i = 0; i < this.listCheckBoxTpv.length; i++) {
                        this.idsTPV.push(this.listCheckBoxTpv[i].id)
                    }
                } else {
                    this.idsTPV = []
                    this.idsTPV.push(this.idTpv)
                }

                this.getVentas();
            },
            getVentas() {

                this.$modal.hide('filtradoTPV');

                if (this.idBusiness.length > 0) {

                    if (this.datefrom === null || this.dateto === null) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    } else {

                        if (this.busquedaPorHoras) {

                            this.getVentasConHoras()
                        } else {

                            this.getVentasSinHoras();

                        }
                    }
                }

            },
            getVentasSinHoras() {

                let secondsDesde = moment(this.datefrom).startOf("day").unix();
                let secondsHasta = moment(this.dateto).endOf("day").unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {

                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    this.loading = true;

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            idTpv: this.idsTPV,
                            datefrom: secondsDesde,
                            dateto: secondsHasta,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let controller = "";


                    if (this.graficaVentas === 0) {

                        controller = 'getVentasByPedidos';

                    } else if (this.graficaVentas === 1) {

                        controller = 'getSalesByBusinessWeek';
                    } else if (this.graficaVentas === 3) {

                        controller = 'getSalesByBusinessMonth';
                    } else if (this.graficaVentas === 4) {

                        controller = 'getSalesByBusinessHours';
                    } else {

                        controller = 'getSalesByBusinessYear';
                    }


                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios.get(this.$store.getters.apiUrl + "products/" + controller, config)
                        .then(function (response) {

                            if (response.data.response) {
                                vm.data = "";
                                vm.data = response.data.result;
                                if (vm.graficaVentas === 0) {

                                    vm.initChart();

                                } else {

                                    vm.initChartLista();
                                }

                                if (vm.grafica === 4) {

                                    vm.initChartWeek();
                                }

                                vm.respuesta = true;
                            }else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                    });
                                    vm.respuesta = false;
                            }  else {

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                                vm.respuesta = false;

                            }
                            vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },
            getVentasConHoras() {


                let secondsDesde = moment(this.datefrom).startOf("day").unix();
                let secondsHasta = moment(this.dateto).endOf("day").unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {

                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    this.loading = true;

                    let fechaDesHours = moment(this.hoursfrom, 'HH:mm:ss').format("HH:mm:ss");
                    let fechaHastHours = moment(this.hoursto, 'HH:mm:ss').format("HH:mm:ss");


                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            idTpv: this.idsTPV,
                            busquedaPorApertura: this.busquedaPorApertura,
                            datefrom: secondsDesde,
                            dateto: secondsHasta,
                            hoursfrom: fechaDesHours,
                            hoursto: fechaHastHours,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios.get(this.$store.getters.apiUrl + "products/getSalesByBusinessByHours", config)
                        .then(function (response) {
                            if (response.data.response) {
                                vm.data = "";
                                vm.data = response.data.result;

                            } else {

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                            }
                            vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },

            getDayDetail($index) {

                if (this.busquedaPorHoras) {
                    this.$router.push({
                    name: "informe-pedidos-detalle",
                    params: { idDay: this.data[$index].id,
                              idBusiness: this.idBusiness,
                              datefrom: this.datefrom,
                              dateto: this.dateto,
                              hoursfrom: this.hoursfrom,
                              hoursto: this.hoursto
                            },
                    });
                } else {
                    this.$router.push({
                    name: "informe-pedidos-detalle",
                    params: { idDay: this.data[$index].id,
                              idBusiness: this.idBusiness
                    }});
                }
                


            },
            getClassDay(date) {
                var classDay = "";
                var humanDate = moment.unix(date);
                var dia = moment(humanDate).format("d");

                if (dia === "0") {
                    classDay = "sunday";
                } else if (dia == 5 || dia == 6) {
                    classDay = "fridaySaturday";
                }

                return classDay;
            },
            handleTabChange(tabIndex, newTab, oldTab) {
                //TODO
                this.tabs = newTab.title;
                if (this.tabs == "Volver") {
                    this.openDay = false;
                    this.idDay = 0;
                }
            },


            getSumaryWeeks() {

                let secondsDesde = moment(this.datefrom).startOf("day").unix();
                let secondsHasta = moment(this.dateto).endOf("day").unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {

                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    this.loading = true;

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            idTpv: this.idsTPV,
                            datefrom: secondsDesde,
                            dateto: secondsHasta,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios.get(this.$store.getters.apiUrl + "sales/getSumaryWeeks", config)
                        .then(function (response) {
                            if (response.data.response) {

                                vm.listGrafic = response.data.result;

                                vm.initChartWeek();
                            } else {

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                            }
                            vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },

            getSumaryHours() {

                let secondsDesde = moment(this.datefrom).startOf("day").unix();
                let secondsHasta = moment(this.dateto).endOf("day").unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {

                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    this.loading = true;

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            idTpv: this.idsTPV,
                            datefrom: secondsDesde,
                            dateto: secondsHasta,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios.get(this.$store.getters.apiUrl + "sales/getSumaryHours", config)
                        .then(function (response) {
                            if (response.data.response) {

                                vm.listGrafic = response.data.result;

                                vm.initChartWeek();
                            } else {

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                            }
                            vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },

            initChartLista() {

                if (this.graficaVentas === 0) {

                    let vm = this;
                    var labels = this.data.map(function (x) {
                        return moment.unix(x.initDate).format("DD-MM-YYYY");
                    });

                } else if (this.graficaVentas === 1) {

                    let vm = this;
                    var labels = this.data.map(function (x) {
                        var humanDate = moment.unix(x.initDate);
                        return moment(humanDate).format("dddd");
                    });

                } else if (this.graficaVentas === 3) {

                    let vm = this;
                    var labels = this.data.map(function (x) {
                        var humanDate = moment.unix(x.initDate);
                        return moment(humanDate).format("MMMM");
                    });
                } else if (this.graficaVentas === 4) {

                    let vm = this;
                    var labels = this.data.map(function (x) {
                        return x.horas;
                    });
                }


                let total = 0;
                let count = 0;

                if (this.graficaVentas === 1 || this.graficaVentas === 2 || this.graficaVentas === 3) {

                    var data = this.data.map(function (x) {
                        return x.money  + x.cards;
                    });
                } else {

                    var data = this.data.map(function (x) {
                        return x.amount;
                    });
                }

                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });


                if (this.objectChartList !== null) {
                    this.objectChartList.destroy();
                }

                this.objectChartList = new Chart('chartList', {

                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                data: data,
                                backgroundColor: "rgba(192,214,8,0.3)",
                                borderWidth: 1
                            }]
                    },
                    options: {
                        legend: {
                            display: false,
                            position: 'bottom',
                        },
                        maintainAspectRatio: false,


                    }
                });

            },

            initChart() {


                let vm = this;
                var labels = this.data.map(function (x) {
                    return moment.unix(x.initDate).format("DD-MM-YYYY");
                });


                let total = 0;
                let count = 0;


                var labelsMedia = this.data.map(function (x) {
                    count++;
                    total += x.money  + x.cards;

                    return total / count;
                });

                var data = this.data.map(function (x) {
                    return x.money  + x.cards;
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });


                if (this.objectChart !== null) {
                    this.objectChart.destroy();
                }

                this.objectChart = new Chart('chart', {

                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                data: labelsMedia,
                                borderWidth: 3,
                                backgroundColor: "rgba(168,0,0,0.3)",
                                borderColor: "rgba(168,0,0,0.3)",
                                type: 'line',
                                fill: false,

                            }, {
                                data: data,
                                backgroundColor: "rgba(192,214,8,0.3)",
                                borderWidth: 1
                            }]
                    },
                    options: {
                        legend: {
                            display: false,
                            position: 'bottom',
                        },
                        maintainAspectRatio: false,


                    }
                });

            },


            initChartWeek() {


                if (this.grafica == 2) {

                    let vm = this;
                    var labels = this.listGrafic.map(function (x) {
                        return x.dias;
                    });

                    var data = this.listGrafic.map(function (x) {
                        return x.amount;
                    });
                } else if (this.grafica == 3) {


                    let vm = this;
                    var labels = this.listGrafic.map(function (x) {
                        return x.horas + ' h';
                    });

                    var data = this.listGrafic.map(function (x) {
                        return x.amount;
                    });
                } else if (this.grafica == 4) {

                    let vm = this;
                    var labels = this.data.map(function (x) {
                        var humanDate = moment.unix(x.initDate);

                        return moment(humanDate).format("MMMM");

                    });

                    var data = this.data.map(function (x) {
                        return x.money  + x.cards;
                    });
                }


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });


                if (this.objectChart !== null) {
                    this.objectChart.destroy();
                }

                this.objectChart = new Chart('chart', {

                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: backgroundColors,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        legend: {
                            display: false,
                            position: 'bottom',
                        },
                        maintainAspectRatio: false,


                    }
                });

            }


        }


    }
</script>

<style scoped>

    .active-filter {
        color: #1E22AA;
        border-color: #b9d0d7;
        background-color: #e8eff2;
    }

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    .sunday {
        color: rgb(128, 0, 0);
    }

    .fridaySaturday {
        color: rgb(0, 128, 64);
    }

    .trDay:hover {
        background-color: rgba(68, 125, 247, 0.2) !important;
    }

    .justify-content-right{
        margin-left: 15px;
    }
   

</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Pedidos/InformePedidos.vue